"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHeaderMenuContextValue = exports.useHeaderMenuContextProvider = void 0;
const react_1 = __importDefault(require("react"));
const HeaderMenuContext = react_1.default.createContext({
    isMenuSticked: false,
    setIsMenuSticked: () => { },
});
const useHeaderMenuContextProvider = () => {
    const [isMenuSticked, setIsMenuSticked] = react_1.default.useState(false);
    return {
        HeaderMenuContextProvider: HeaderMenuContext.Provider,
        value: {
            isMenuSticked,
            setIsMenuSticked,
        },
    };
};
exports.useHeaderMenuContextProvider = useHeaderMenuContextProvider;
const useHeaderMenuContextValue = () => {
    const context = react_1.default.useContext(HeaderMenuContext);
    return context;
};
exports.useHeaderMenuContextValue = useHeaderMenuContextValue;
